import { render, staticRenderFns } from "./rumorList.vue?vue&type=template&id=660e6ccc&scoped=true"
import script from "./rumorList.vue?vue&type=script&lang=js"
export * from "./rumorList.vue?vue&type=script&lang=js"
import style0 from "./rumorList.vue?vue&type=style&index=0&id=660e6ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660e6ccc",
  null
  
)

export default component.exports